'use strict';

const trackingUtils = require('../../modules/utils/tracking.utils');
const tripTypeUtils = require('../../modules/utils/trip_type');
const resultsTracking = require('../../modules/results/tracking.js');
const SavingAlertView = require('../../modules/views/saving_alert.view.js');
const fareUpgradeTracking = require('../../tracking/fare_upgrade.js');
const flightChangeFreeUtil = require('../../modules/utils/flight_change_free');

const parseSelectedFlightInfo = function(segment) {
    return {
        departure: segment.departureInfo.name,
        arrival: segment.arrivalInfo.name,
        dtime: segment.departureInfo.time,
        atime: segment.arrivalInfo.time,
        ddate: segment.departureInfo.date,
        jsDepartureDate: segment.departureInfo.jsFormattedDate,
        jsArrivalDate: segment.arrivalInfo.jsFormattedDate,
        carriercode: segment.carrierCode,
        itineraryType: segment.segmentType,
        segmentDuration: segment.segmentDuration,
        isLongHaul: segment.isLongHaul,
    };
};

module.exports = {
    updateCompressedHeader: Odigeo._.noop,
    requestFlexibleDates: function() {
        if (tripTypeUtils.ofResults().isOneWayOrRoundTrip(this.model.get('searchType'))) {
            Odigeo.trigger(this.id + ':getFlexibleDates', {
                isNewSearch: this.model.isNewSearch(),
                tripType: this.model.get('searchType'),
                flexibleDatesInfo: Odigeo._.get(this.model.get('data'), 'flexibleDatesInfo'),
            });
            this.model.unSetSearchOrigin();
        }
    },
    trackMembership: function(membershipTrackLabel) {
        var isMembershipPriceOrDualPriceDisplay = this.model.get('isMembershipPriceOrDualPriceDisplay');
        const {
            membershipPriceDisplayDesktop,
            membershipPriceDisplayMobile,
        } = Odigeo.Membership;
        if (isMembershipPriceOrDualPriceDisplay ||
            membershipPriceDisplayDesktop === 'FILTER_STICKY' ||
            membershipPriceDisplayMobile === 'FILTER') {
            trackingUtils.trackEvent('unlocked', membershipTrackLabel, null);
        }
    },

    loadItineraryDetails: function($wrapper) {
        if (!Odigeo.Utils.isRequestApp('dp') || Odigeo.AB.isDynpackAndXSellDetailsV1 ) {
            this.triggerItineraryDetails($wrapper);
        } else {
            var widgetData = $wrapper.find('.itinerary_details').data('itineraryDetails');
            if (!$wrapper.find('.itinerary_details').attr('data-loaded')) {
                var fareItineraryId = widgetData.fareitinerary;
                var itineraryGroupId = widgetData.itinerarygroup;
                var segmentId = Odigeo._.parseInt(widgetData.segmentId) + 1;
                var itineraryIsHub = widgetData.isHub;
                var itineraryIsSmartHub = widgetData.isSmartHub;
                var searchId = widgetData.searchId;
                this.model.getSegmentDetails(fareItineraryId, itineraryGroupId, segmentId, itineraryIsHub, itineraryIsSmartHub, searchId)
                    .success(Odigeo._.bind(function(data) {
                        if (data.trim().length === 0) {
                            $wrapper.addClass('hidden');
                            Odigeo.UIElements.showSearchExpiredError();
                        } else {
                            $wrapper.find('.itinerary_details').attr('data-loaded', true);
                            $wrapper.find('.itinerary_loader').replaceWith(data);
                        }
                    }, this));
            }
        }
    },

    triggerItineraryDetails($wrapper) {
        const {itinerarygroup, segmentId, fareitinerary} = $wrapper.find('.itinerary_details').data('itineraryDetails');
        Odigeo.trigger('results-manager:showFlightInfo', {
            itinerary: {
                mainItineraryId: fareitinerary,
            },
            segmentPositions: [
                {
                    leg: Odigeo._.parseInt(itinerarygroup) - 1,
                    segment: Odigeo._.parseInt(segmentId),
                },
            ],
            offset: {top: $wrapper.offset().top},
        });
    },

    segmentDetailsHandler: function(e, widget) {
        var $wrapper = $(e.currentTarget).closest('div.itinerary_row');
        var $details = $wrapper.find('.details');
        var label = 'open_segment_info';

        widget.widget.execute('loadItineraryDetails', $wrapper);
        $details.toggleClass('expanded');
        if (!$details.hasClass('hidden')) {
            widget._updateHeigth();
            label = $(e.currentTarget).hasClass('hide_details_btn') ? 'closed_segment_info_bottom' : 'closed_segment_info_top';
        }
        // Analytics: event tracking
        trackingUtils.trackEventWithCategory('flights_results', 'results_list', label);

        $details.trigger('toggleExpandable');
        e.stopPropagation();
    },

    searchFlightsHandler: function() {
        this.invalidateResults();
    },

    clear: function() {
        // this.view.clearResults();
        this.pageBottomRequested = 0;
        this.pageBottomLoaded = 0;
        this.pageTopRequested = 1;
        this.pageTopLoaded = 1;
        this.pageToLoad = 1;
        this.selectedSearchResults = '';
        this.dynpackCartProductId = null;
        this.dpCart = null;
    },

    clearResults: function() {
        this.clear();
        this.view.clearResults();
    },

    scrollToZeroResults: function() {
        Odigeo.trigger(this.id + ':backToTop', {top: 90, left: 0, duration: 500});
    },

    invalidateResults: function(params) {
        var widget = this;
        var resultsContainer = widget.options.isDynpack ? $('#dpresults_flights') : $('#results');
        var $filtersButton = $('#filters_button');
        var $headerDestCity = resultsContainer.find('.header_destination_city');
        var hasResults;
        widget.model.delta = 1;
        this.model.isFiltering = (params && !!params.isFiltering);
        this.clear();
        if (params) {
            this.model.numberOfResults = params.numResults;
            this.model.numberOfFilteredResults = params.numFilteredResults;
            this.model.numberOfResultsNotMatchedFilters = params.numResultsNotMatchedFilters;
            this.model.cheapestPriceNotMatchedFilter = params.cheapestPriceNotMatchedFilter;
            this.model.numberOfPreFilteredResults = params.numPreFilteredResults;
            this.dynpackCartProductId = params.dynpackCartProductId;
            this.dpCart = params.dpCart;
        } else {
            var resultsCount = parseInt(Odigeo.Storage.get('results_count'), 10);
            this.model.numberOfResults = resultsCount;
            this.model.numberOfPreFilteredResults = resultsCount;
        }
        hasResults = this.model.numberOfFilteredResults > 0;
        if (hasResults || this.model.numberOfFilteredResults === this.model.numberOfPreFilteredResults) {
            if (Odigeo.AB.isChangeFlightFreeChargeDesktop || Odigeo.AB.isChangeFlightFreeChargeMobile || Odigeo.AB.isPrimeDays) {
                flightChangeFreeUtil.refreshFlightChangeFreeAirlines(true).then(this.view.loadResults.bind(this.view));
            } else {
                this.view.loadResults();
            }
        }
        resultsContainer.find('.resultspage_section').removeClass('odf-hidden');
        $filtersButton.removeClass('odf-hidden');

        var destinationCity;
        var isDynpack = Odigeo.Utils.isRequestApp('dp');
        var searchData = isDynpack ? Odigeo.Storage.get('lastSearchDynpack') : Odigeo.Storage.get('search-data');
        var data = Odigeo.Utils.parseJson(searchData);
        data = Odigeo._.isArray(data) ? data[0] : data;
        if (Odigeo._.isObject(data) && $headerDestCity.length > 0) {
            destinationCity = data.searchSegments[0].destination.city;
            $headerDestCity[0].innerHTML = destinationCity;
        }

        resultsContainer.find('.title_header').removeClass('odf-hidden');
        resultsContainer.find('.calendargrid_wrapper').removeClass('hidden');
        widget.view.$widget.find('.results_header_title, .results_footer').removeClass('odf-hidden');

        Odigeo.trigger(widget.id + ':showHiddenElements');
        Odigeo.trigger(widget.id + ':showAppTouchPointBottom');
    },

    changePaymentDisclaimer: function(ccid, ccName) {
        var widget = this;
        if (ccid) {
            widget.model.set({
                'creditCardID': ccid,
                'creditCardName': ccName,
            });
        } else {
            ccid = widget.model.get('creditCardID');
            if (!ccid) {
                return;
            }
        }
    },

    disableResults: function() {
        this.view.disableResults();
    },

    enableResults: function() {
        this.view.enableResults();
    },

    bookFlightErrorHandler: function(xhr) {
        this.model.requestErrorHandler(xhr);
    },

    resetAveragePrice: function() {
        this.model.set('averagePrice', 0);
    },

    resetCreditCardSelection: function() {
        // Reset credit card selector to "Cheapest method"
        if (this.view.$cachedSelectors.creditCardSelector) {
            this.view.$cachedSelectors.creditCardSelector.val(0);
            var creditCardText = this.view.$cachedSelectors.creditCardSelector.find('option[value=\'0\']').text();
            this.view.$widget.find('.selected_credit_card').html(creditCardText);
        }
    },

    updateSelectorToCache: function(cachedName, selector) {
        var $cachedSelectors = {};

        if (this.view.$cachedSelectors) {
            $cachedSelectors = this.view.$cachedSelectors;
        }

        if ($cachedSelectors[cachedName]) {
            this.view.removeSelectorFromCache(cachedName);
        }
        this.view.addSelectorToCache(cachedName, selector);
    },

    setLastSelection: function(flights) {
        let $result;
        let $selectionSegments;
        let $selectionRadio;
        const bookedFlights = [flights[0], flights[1]];
        const itineraries = this.model.get('data').items;

        var selectionItinerary = _(itineraries).find(function(itinerary) {
            var dataFlights = _(itinerary.itineraryGroupsList)
                .map(Odigeo._.property('segItems'))
                .flatten()
                .map(parseSelectedFlightInfo)
                .map(Odigeo._.partial(Odigeo._.find, bookedFlights))
                .filter()
                .value();
            return Odigeo._.isEqual(Odigeo._.sortBy(bookedFlights), Odigeo._.sortBy(dataFlights));
        });

        if (!Odigeo._.isEmpty(selectionItinerary)) {
            var fareItineraryId = selectionItinerary.mainItineraryId;
            $result = this.view.$cachedSelectors.resultsContainer.find('.result[data-fare-itinerary-id="' + fareItineraryId + '"]');
            $selectionSegments = $result.find('.itinerary_row');
            $selectionRadio = $selectionSegments.find('.result_radio_container .radio').not('checked');

            $selectionRadio.eq(0).trigger(Odigeo.Events.tap);
            $selectionRadio.eq(1).trigger(Odigeo.Events.tap);
            Odigeo.trigger(this.id + ':highlightPreselected', {
                fareItinerary: {
                    id: fareItineraryId,
                },
            });
        }
    },

    highlightPreselected: function(model, selected) {
        var hasSelectedFlight = !Odigeo._.isUndefined(selected.fareItinerary) && !Odigeo._.isUndefined(selected.fareItinerary.id);
        var isChangedItinerary = hasSelectedFlight && Odigeo._.keys(selected.fareItinerary).join() === 'id';
        var isChangedTimer = !isChangedItinerary && model.fareItinerary.id === selected.fareItinerary.id &&
            !Odigeo._.isEqual(model.fareItinerary, selected.fareItinerary);
        var selectedClass = 'selected';
        var $result = $('.result');

        if (isChangedItinerary || model.fareItinerary.id === selected.fareItinerary.id) {
            $result
                .removeClass(selectedClass)
                .filter('.result[data-fare-itinerary-id="' + model.fareItinerary.id + '"]')
                .toggleClass(selectedClass, isChangedItinerary || !isChangedTimer);
        }
    },

    trackOnLoadTrains: function() {
        this.resultsTracking.trackOnLoadTrains();
    },

    trackOnLoadEvents: function() {
        this.resultsTracking.trackOnLoad();
    },

    deleteNonStopFlightManager: function() {
        // TODO this method does not use elements of widget view. This code should be extracted to another widget.
        var $results = $('#results');
        var $alert = $results.find('.alert_no_direct_flights');
        if ($alert.attr('data-skip-enhance')) {
            $results.find('.title_header').removeClass('odf-hidden');
            Odigeo.UIElements.enhanceAlert($alert).trigger('deleteMessage');
        }
    },

    showNonStopFlightsMessage: function() {
        // TODO this method does not use elements of widget view. This code should be extracted to another widget.
        var $results = $('#results');
        $results.find('.title_header').addClass('odf-hidden');
        Odigeo.UIElements.enhanceAlert(
            $results.find('.alert_no_direct_flights'), {
                icon: '!',
                type: 'warning',
                message: Odigeo.UIElements.translations.alertsMessages.nodirectflights,
            })
            .trigger('showMessage', 2000);
    },

    getDataFirstResultPrice: function(data) {
        return this.model._getDataFirstResultPrice(data);
    },

    // TODO: remove publicMethods hash object and overwritten execute method and adapt to use with inherited execute widget method.
    publicMethods: {
        mustOpenSearchSummary: 'model.mustOpenSearchSummary',
        getRecommendedItinerary: 'model.getRecommendedItinerary',
        getBestFlightItinerary: 'model.getBestFlightItinerary',
        clearResults: 'clearResults',
        bookBtnPositionHandler: 'view.bookBtnPositionHandler',
        trackMPIResponseTime: 'trackMPIResponseTime',
        hideWaitingPage: 'view.hideWaitingPage',
        showNoResultsScreen: 'view.showNoResultsScreen',
        showNoFilteredResultsScreen: 'view.showNoFilteredResultsScreen',
        deleteNonStopFlightManager: 'deleteNonStopFlightManager',
        showNonStopFlightsMessage: 'showNonStopFlightsMessage',
        disableResults: 'view.disableResults',
        enableResults: 'view.enableResults',
        invalidateResults: 'invalidateResults',
        setLastSelection: 'setLastSelection',
        setActiveTab: 'model.set@activeTab',
        bookFlightErrorHandler: 'bookFlightErrorHandler',
        resetAveragePrice: 'resetAveragePrice',
        loadItineraryDetails: 'loadItineraryDetails',
        resetCreditCardSelection: 'resetCreditCardSelection',
        setSearchOrigin: 'model.setSearchOrigin',
        trackAfterDrawResults: 'trackAfterDrawResults',
        trackOnLoadEvents: 'trackOnLoadEvents',
        trackOnLoadTrains: 'trackOnLoadTrains',
        highlightPreselected: 'highlightPreselected',
        scrollToZeroResults: 'scrollToZeroResults',
        allowToRefresh: 'model.set@allowedRefresh',
        clearPrimeFilter: 'model.set@isMembershipFare',
        changeMainSearch: 'model.changeMainSearch',
        setFiltersButtonMeasures: 'view.setFiltersButtonMeasures',
        updateDisplayedPrices: 'updateDisplayedPrices',
        trackMembership: 'trackMembership',
        loadResults: 'view.loadResults',
        changePriceDiscountSelected: 'changePriceDiscountSelected',
        bookFlight: 'bookFlight',
        setIsFareUpgradeAvailable: 'view.setIsFareUpgradeAvailable',
        setFiltersApplied: 'model.set@isFiltersApplied',
        toggleSortingTabs: 'view.toggleSortingTabs',
        blockSortingTabs: 'view.blockSortingTabs',
        togglePaymentMethodFooter: 'view.togglePaymentMethodFooter',
        toggleAppTouchpoint: 'view.toggleAppTouchpoint',
        toggleFreeCancellationResults: 'view.toggleFreeCancellationResults',
        getBookedFlights: 'getBookedFlights',
        trackMoreClickedLink: 'trackMoreClickedLink',
        getSeatsLeft: 'model.get@seatsLeft',
    },

    getBookedFlights: function() {
        return this.model.getBookedFlights();
    },

    changePriceDiscountSelected: function(data) {
        this.view.changePriceDiscountSelected(data.resultContainer, true);
    },

    bookFlight: function(data) {
        this.view.bookFlight(data);
    },

    execute: function(func) {
        return Odigeo.Utils.executeInternalMethods(this, this.publicMethods, func, Odigeo._.rest(arguments));
    },

    init: function() {
        // Set options
        Odigeo._.defaultsDeep(this.options, {
            baggage: {
                showToolTip: false,
            },
        });
        // size of results on each results page
        this.resultsByPage = parseInt(this.options.result_perpage, 10);
        // maximum amount of pages loaded in any given time
        this.maxLoadedPages = parseInt(this.options.maxLoadedPages, 10);
        // number of pages to be shown in pagination
        this.paginationType = this.options.paginationType;
        // Does the widget use a native input?
        this.isNativeInput = parseInt(this.options.isNativeInput, 10);
        // Product
        this.isDynpack = this.options.isDynpack;
        // main search set of results
        this.selectedSearchResults = '';

        this.resultsTracking = Odigeo._.reduce(resultsTracking, Odigeo._.bind(function(memo, method, methodName) {
            memo[methodName] = Odigeo._.bind(method, this);
            return memo;
        }, this), {});

        this.fareUpgradeTracking = Odigeo._.reduce(fareUpgradeTracking, Odigeo._.bind(function(memo, method, methodName) {
            memo[methodName] = Odigeo._.bind(method, this);
            return memo;
        }, this), {});
    },

    setSavingAlerts: function() {
        const {translations, tests, savingAlertsMinBoundary} = this.options;
        var items = this.model.get('data').items;

        this.view.$el.find('.results_saving_alert').each(Odigeo._.bind(function(i, itinerary) {
            $(itinerary).removeClass('results_saving_alert');
            const selectedPrice = items[i] && items[i].price || 0;
            var savingAlert = new SavingAlertView({
                selectedPrice,
                averagePrice: this.model.get('averagePrice'),
                minBoundary: savingAlertsMinBoundary,
                template: this.view.templates.savingAlert,
                translations,
                tests,
            });
            items[i].percentage = savingAlert.percentage;
            savingAlert.render();
            $(itinerary).html(savingAlert.$el);
        }, this));
    },
    trackMPIResponseTime: function() {
        var startTime = Odigeo.Storage.get('mpiRouteStartSearch');
        var endTime = Odigeo.Utils.getDifferenceInMilliseconds(startTime, Date.now());
        var departureIATA = Odigeo.Storage.get('departureIATA');
        var destinationIATA = Odigeo.Storage.get('destinationIATA');
        var label = 'mpi_' + departureIATA + '_' + destinationIATA + '_' + endTime;
        trackingUtils.trackEventWithCategory('flights_results', 'mpi_test', label);
        this.removeMPIFromSession();
    },
    removeMPIFromSession: function() {
        Odigeo.Storage.remove('mpiRouteStartSearch');
        Odigeo.Storage.remove('departureIATA');
        Odigeo.Storage.remove('destinationIATA');
    },
    updateDisplayedPrices: function(isMembershipFare) {
        this.model.set('isMembershipFare', isMembershipFare);
        this.model.refresh();
    },
    trackMoreClickedLink: function() {
        this.view.trackMoreClickedLink();
    },

    // START vars for "loadMore" pagination type
    // Results page that has been requested to backend
    backToTop: false,
    pageTopRequested: 1,
    pageBottomRequested: 0,
    // Results page that actually has been loaded from backend
    pageTopLoaded: 1,
    pageBottomLoaded: 0,
    // END vars for "loadMore"
    pageToLoad: 1,
    paginationType: '',
    // delta to the end of the page to load new results
    LAZY_LOADING_DELTA: 500,
    // threshold for back to top button
    isNativeInput: false,
    BACK_TO_TOP_THRESHOLD: 800,
    parseSelectedFlightInfo: parseSelectedFlightInfo,
};
